
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 .375h12A5.625 5.625 0 0123.625 6v12A5.625 5.625 0 0118 23.625H6A5.625 5.625 0 01.375 18V6A5.625 5.625 0 016 .375z","fill":"#F0F0F0"}}),_c('path',{attrs:{"d":"M6 .375h12A5.625 5.625 0 0123.625 6v12A5.625 5.625 0 0118 23.625H6A5.625 5.625 0 01.375 18V6A5.625 5.625 0 016 .375z","stroke":"#EBEBEB","stroke-width":".75"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"9k5bj4jdua","maskUnits":"userSpaceOnUse","x":"4","y":"4","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M4 4h16v16H4z"}})]),_c('g',{attrs:{"mask":"url(#9k5bj4jdua)"}},[_c('path',{attrs:{"d":"M10 14.667h4a.645.645 0 00.475-.192.645.645 0 00.192-.475v-4a.645.645 0 00-.192-.475.645.645 0 00-.475-.192h-4a.645.645 0 00-.475.192.645.645 0 00-.191.475v4c0 .189.063.347.191.475a.645.645 0 00.475.192zm2 4a6.492 6.492 0 01-2.6-.525 6.732 6.732 0 01-2.117-1.425A6.733 6.733 0 015.859 14.6a6.492 6.492 0 01-.524-2.6c0-.922.175-1.789.525-2.6a6.732 6.732 0 011.425-2.117c.6-.6 1.305-1.075 2.116-1.425a6.492 6.492 0 012.6-.525c.922 0 1.79.175 2.6.525.811.35 1.517.825 2.117 1.425.6.6 1.075 1.306 1.425 2.117.35.811.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 01-1.425 2.117c-.6.6-1.306 1.075-2.117 1.425a6.492 6.492 0 01-2.6.525zm0-1.334c1.49 0 2.75-.516 3.784-1.55 1.033-1.033 1.55-2.294 1.55-3.783 0-1.489-.517-2.75-1.55-3.783-1.034-1.034-2.295-1.55-3.784-1.55-1.489 0-2.75.516-3.783 1.55C7.183 9.25 6.667 10.51 6.667 12c0 1.489.517 2.75 1.55 3.783 1.033 1.034 2.294 1.55 3.783 1.55z","fill":"#757575"}})])])
          )
        }
      }
    